import React from 'react';

import constants from 'client/constants';
import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';

interface Props {
  pathname: string;
  search: string;
  /** The page stays in Dennis during the rollout (route `staticData.dennisOnly`). */
  dennisOnly: boolean;
}

/**
 * Switches between Dennis and Deedee while both run side by side. Deedee renders the same
 * control in the same spot. Remove both once the two share one navigation.
 */
export function AppSwitcher({pathname, search, dennisOnly}: Props) {
  const {isFeatureEnabled} = useIsFeatureFlagEnabled('dennis_deedee_switcher');

  if (!isFeatureEnabled) {
    return null;
  }

  const deedeeUrl = `${constants.MANDARK_FULL_PATH}/deedee/open?path=${encodeURIComponent(
    pathname + search
  )}`;

  return (
    <div
      role='group'
      aria-label='Switch app'
      data-testid='app-switcher'
      className='mr-x1 bg-background-primary/15 p-x0-quarter content-primary-inverse-static my-auto flex shrink-0 items-center rounded-full text-xs leading-[18px] font-semibold'
    >
      <span
        aria-current='page'
        className='background-primary px-x1 py-x0-quarter content-brand rounded-full'
      >
        Dennis
      </span>
      {dennisOnly ? (
        <span
          aria-disabled='true'
          className='px-x1 py-x0-quarter cursor-not-allowed rounded-full opacity-60'
          title='This page stays in Dennis for now'
        >
          Deedee Beta
        </span>
      ) : (
        <a
          href={deedeeUrl}
          data-testid='app-switcher-deedee'
          className='px-x1 py-x0-quarter hover:bg-background-primary/15 rounded-full text-inherit no-underline'
          title='Open this page in Deedee'
        >
          Deedee Beta
        </a>
      )}
    </div>
  );
}
